<script setup lang="ts">
const { t } = useI18n()
const emit = defineEmits<{ (e: 'onGoBack'): void }>()
</script>

<template>
  <div class="flex h-screen flex-col items-center justify-center bg-muted p-4">
    <div class="flex w-full max-w-[400px] flex-col items-center rounded-lg border bg-white p-5">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
        <BaseIcon name="HeroExclamationTriangleIconOutline" class="h-6 w-6 text-yellow-600" />
      </div>
      <p class="my-5 text-center text-sm">
        {{ t('pages.theTooSmallScreenPage.disclaimer') }}
      </p>
      <Button variant="default-primary" class="w-full" @click="emit('onGoBack')">
        {{ t('global.words.back') }}
      </Button>
    </div>
  </div>
</template>
